import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=23153f5f&scoped=true"
import script from "./SearchIcon.vue?vue&type=script&lang=ts"
export * from "./SearchIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23153f5f",
  null
  
)

export default component.exports